import Vue from 'vue';
import Vuex from 'vuex';
import services from './services'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'

import { oidcSettings, oidcSettingsDev } from '../config/oidc'
import { axiosSingleton } from "@/plugins/axios";
// import { oidcSettings } from '../plugins/oidc'
import user from "./user";

Vue.use(Vuex)

const state = {services}

export default new Vuex.Store({
    modules: {
        user,
        oidcStore: vuexOidcCreateStoreModule(
          oidcSettings,
          {
            namespaced: true,
            dispatchEventsOnWindow: true
          },
          {
            userLoaded(user) {axiosSingleton.getInstance().defaults.headers.common['Authorization'] = `Bearer ${user.id_token}`},
            userUnloaded: () => console.log('OIDC user is unloaded'),
            accessTokenExpiring: () => console.log('Access token will expire'),
            accessTokenExpired: () => console.log('Access token did expire'),
            silentRenewError: () => console.log('OIDC user is unloaded'),
            userSignedOut: () => console.log('OIDC user is signed out'),
         
          }
        )
      },
    state: {
      empleadoDatos: null,
    },
    mutations: {    
      setCategorias (state, payload) {
      state.categorias = payload
      },
      setEmpleado(state, data) {
        state.empleadoDatos = data;
    },
    },
    actions: {   
    async obtenerEmpleado({ state }) {
        await axiosSingleton.getInstance()
            .get(`https://enjambrec.ugto.mx/DSI/perfil?cliente=PLADI`, {
            })
            .then((res) => this.commit('setEmpleado', res.data))
            // .then(res => console.log("empleado", res.data))
            .catch((error) => console.log(error));
        //console.log('this.state.oidc', this.state.oidc);
    },
      async getCategorias () {
      const res = await this.$axios.get('dsi/tablero/api/categorias', { headers: { 'Authorization': `Bearer ${this.state.oidc.id_token}` } })
      this.commit('setCategorias', res.data)
    }},

    
})